'use client';
import { FC } from 'react';
import { useCmsClientContext } from '../utils/cmsPageContext';
import { getClientTranslations } from '../utils/translations/getClientTranslations';
import { staticText } from '../utils/translations/staticText';
import ArrowTopIcon from './icons/ArrowTopIcon';

const Translations = staticText({
  back_to_top: {
    _: 'Back To Top',
    zh: '返回頂端',
  },
});

interface BackToTopProps {
  className?: string;
}

const BackToTop: FC<BackToTopProps> = ({ className = '' }) => {
  const { lang, brand } = useCmsClientContext();
  const staticText = getClientTranslations(Translations, { lang, brand });
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      className={`
        mhg-alpha-typography-body-1 inline-flex items-center
        gap-spacing/gap/soft-4px
        underline
        transition-colors
        duration-200
        text-secondary-lighter
        ${className}
      `}
    >
      <ArrowTopIcon />
      <span>{staticText.back_to_top}</span>
    </button>
  );
};

export default BackToTop;
